import type { ComponentProps } from "react";
import { cn } from "../lib/cn";

export const inputClassName =
  "flex h-8 w-full min-w-0 rounded-md border border-border bg-bg px-2.5 text-sm text-fg field-focus placeholder:text-fg-faint hover:border-border-strong disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-danger";

export type InputProps = ComponentProps<"input">;

export function Input({ className, type = "text", ...props }: InputProps) {
  return (
    <input data-slot="input" type={type} className={cn(inputClassName, className)} {...props} />
  );
}
